import { defaultTo } from 'ramda';
import { ERecommendedPackageGiftServiceType } from '../../../../../types/reducers/recommendedPackages';

const SERVICE_TYPES_NAMES = {
  [ERecommendedPackageGiftServiceType.Top3]: 'Топ',
  [ERecommendedPackageGiftServiceType.Premium]: 'Премиум',
  [ERecommendedPackageGiftServiceType.Paid]: 'Публикации',
  [ERecommendedPackageGiftServiceType.Publication]: 'Публикации',
  [ERecommendedPackageGiftServiceType.Standard]: 'Стандарт',
  [ERecommendedPackageGiftServiceType.Auction]: 'Баллы',
};

export const getGiftServiceName = (serviceName: ERecommendedPackageGiftServiceType): string => {
  return defaultTo('', SERVICE_TYPES_NAMES[serviceName]);
};
